import { createStandaloneToast } from '@chakra-ui/react';
import { theme } from '~/styles/theme/chakra';
import { translateLiteral } from '~/i18n';
import type { SupportedLanguage } from '~/i18n/translations';

const toast = createStandaloneToast({ theme });

const getCurrentLanguage = (): SupportedLanguage => {
  if (typeof window === 'undefined') return 'pt-BR';
  const value = window.localStorage.getItem('app.language');
  if (value === 'en' || value === 'es' || value === 'pt-BR') return value;
  if (window.navigator.language.toLowerCase().startsWith('es')) return 'es';
  if (window.navigator.language.toLowerCase().startsWith('en')) return 'en';
  return 'pt-BR';
};

export const toastError = (toastId: string, message: string): void => {
  if (!toast.isActive(toastId)) {
    toast({
      description: translateLiteral(message, getCurrentLanguage()),
      status: 'warning',
      position: 'top-right',
      duration: 5000,
      isClosable: true,
    });
  }
};

export const toastSuccess = (toastId: string, message: string): void => {
  if (!toast.isActive(toastId)) {
    toast({
      description: translateLiteral(message, getCurrentLanguage()),
      status: 'success',
      position: 'top-right',
      duration: 5000,
      isClosable: true,
    });
  }
};
